








































































    import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
    import Util from '../../lib/util'
    import AbpBase from '../../lib/abpbase'
    import OrderManagement from '../../store/entities/ordermanagement'
    @Component
    export default class EditOrderManagement extends AbpBase{
        @Prop({type:Boolean,default:false}) value:boolean;
        ordermanagement:OrderManagement=new OrderManagement();
       
       
        save(){

            if(this.ordermanagement.type==1){
                this.ordermanagement.status=2;
            }

            (this.$refs.ordermanagementForm as any).validate(async (valid:boolean)=>{
                if(valid){
                    await this.$store.dispatch({
                        type:'ordermanagement/update',
                        data:this.ordermanagement
                    });
                    (this.$refs.ordermanagementForm as any).resetFields();
                    this.$emit('save-success');
                    this.$emit('input',false);
                }
            })
        }
         get companyinformations(){
            
           
            return this.$store.state.ordermanagement.companyinformations;
        }
          get wastetypes(){
             
            return this.$store.state.ordermanagement.wastetypes;
        }
         isActiveChange(val:string){
                
          
        }
        isOrderType(val:string){
        if(val=="1"){
              this.$store.state.ordermanagement. statusselected=2; 
               this.$store.state.ordermanagement. isShowStatus=false;
                

        }else{
            
               this.$store.state.ordermanagement. statusselected=1; 
               this.$store.state.ordermanagement. isShowStatus=true;
             

        }}
        cancel(){
            (this.$refs.ordermanagementForm as any).resetFields();
            this.$emit('input',false);
        }
        visibleChange(value:boolean){
          
            if(!value){
                this.$emit('input',value);
            }else{
                this.ordermanagement=Util.extend(true,{},this.$store.state.ordermanagement.editOrderManagement);
              //  this.ordermanagement.ordertime=new Date(this.currentTime()) ;
            }
        }
        ordermanagementRule={
             //cid:[{type:'number',required:true,message:this.L('FieldIsRequired',undefined,this.L('CompanyinformationName')),trigger: 'change'}],
             wtid:[{type:'number',required:true,message:this.L('FieldIsRequired',undefined,this.L('WasteType')),trigger: 'change'}],
             status:[{type:'number',required:true,message:this.L('FieldIsRequired',undefined,this.L('OrderStatus')),trigger: 'change'}],
             operators:[{required:true,message:this.L('FieldIsRequired',undefined,this.L('OrderOperators')),trigger: 'blur'}],
             weight:[{required:true,message:this.L('FieldIsRequired',undefined,this.L('OrderWeight'))}],
             ordertime:[{required:true,message:this.L('FieldIsRequired',undefined,this.L('OrderTime'))}]
        }

          currentTime() {
          let nowDate = new Date();
      let date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        date: nowDate.getDate(),
        hours: nowDate.getHours(),
        minutes: nowDate.getMinutes(),
        seconds: nowDate.getSeconds(),
      };      
      let newmonth = date.month > 10 ? date.month : "0" + date.month;
      let newday = date.date > 10 ? date.date : "0" + date.date;
      let newminutes = date.minutes < 10 ? "0" + date.minutes : date.minutes;
      let newseconds = date.seconds < 10 ? "0" + date.seconds : date.seconds;
      // 我需要的时间格式为 "yyyy-MM-dd HH:mm:ss" 有不一样的自己拼别的，都是字符串拼接
      let newTime =
        date.year +
        "-" +
        newmonth +
        "-" +
        newday +
        " " +
        date.hours +
        ":" +
        newminutes +
        ":" +
        newseconds;
        return newTime;
}

created() {
   
}
        
    }
